import canadaImage from '../../data/images/canada.webp';
import turkeyImage from '../../data/images/turkey.webp';

const defaultBg = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082966/socialbnb/containers/OldSTLandingPage/sections/HeroSection/assets/search-bg.webp';
// Import default background image


const vietnam = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082423/socialbnb/assets/countryImages/countryImagesLarge/vietnam.webp';

// Import country images


















































const uzbekistan = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082422/socialbnb/assets/countryImages/countryImagesLarge/uzbekistan.webp';

const uganda = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082421/socialbnb/assets/countryImages/countryImagesLarge/uganda.webp';

const turkey = turkeyImage;

const thailand = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082420/socialbnb/assets/countryImages/countryImagesLarge/thailand.webp';

const tanzania = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082419/socialbnb/assets/countryImages/countryImagesLarge/tanzania.webp';

const sweden = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082418/socialbnb/assets/countryImages/countryImagesLarge/sweden.webp';

const srilanka = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082417/socialbnb/assets/countryImages/countryImagesLarge/srilanka.webp';

const spain = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082416/socialbnb/assets/countryImages/countryImagesLarge/spain.webp';

const southafrica = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082415/socialbnb/assets/countryImages/countryImagesLarge/southafrica.webp';

const scottland = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082413/socialbnb/assets/countryImages/countryImagesLarge/scottland.webp';

const saotome = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082412/socialbnb/assets/countryImages/countryImagesLarge/saotome.webp';

const rwanda = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082412/socialbnb/assets/countryImages/countryImagesLarge/rwanda.webp';

const romania = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082411/socialbnb/assets/countryImages/countryImagesLarge/romania.webp';

const portugal = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082410/socialbnb/assets/countryImages/countryImagesLarge/portugal.webp';

const philippines = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082409/socialbnb/assets/countryImages/countryImagesLarge/philippines.webp';

const peru = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082408/socialbnb/assets/countryImages/countryImagesLarge/peru.webp';

const panama = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082406/socialbnb/assets/countryImages/countryImagesLarge/panama.webp';

const nepal = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082405/socialbnb/assets/countryImages/countryImagesLarge/nepal.webp';

const namibia = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082403/socialbnb/assets/countryImages/countryImagesLarge/namibia.webp';

const morocco = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082402/socialbnb/assets/countryImages/countryImagesLarge/morocco.webp';

const mexico = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082401/socialbnb/assets/countryImages/countryImagesLarge/mexico.webp';

const malta = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082400/socialbnb/assets/countryImages/countryImagesLarge/malta.webp';

const maldives = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082399/socialbnb/assets/countryImages/countryImagesLarge/maldives.webp';

const malawi = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082398/socialbnb/assets/countryImages/countryImagesLarge/malawi.webp';

const jordan = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082398/socialbnb/assets/countryImages/countryImagesLarge/jordan.webp';

const italy = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082397/socialbnb/assets/countryImages/countryImagesLarge/italy.webp';

const indonesia = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082396/socialbnb/assets/countryImages/countryImagesLarge/indonesia.webp';

const india = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082395/socialbnb/assets/countryImages/countryImagesLarge/india.webp';

const greece = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082394/socialbnb/assets/countryImages/countryImagesLarge/greece.webp';

const ghana = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082393/socialbnb/assets/countryImages/countryImagesLarge/ghana.webp';

const germany = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082392/socialbnb/assets/countryImages/countryImagesLarge/germany.webp';

const france = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1784630313/socialbnb/assets/countryImages/countryImagesSmall/france.webp';

const finland = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082391/socialbnb/assets/countryImages/countryImagesLarge/finland.webp';

const estonia = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082390/socialbnb/assets/countryImages/countryImagesLarge/estonia.webp';

const england = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082389/socialbnb/assets/countryImages/countryImagesLarge/england.webp';

const ecuador = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082388/socialbnb/assets/countryImages/countryImagesLarge/ecuador.webp';

const dominicanrepublic = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082387/socialbnb/assets/countryImages/countryImagesLarge/dominicanrepublic.webp';

const croatia = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082386/socialbnb/assets/countryImages/countryImagesLarge/croatia.webp';

const costarica = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082385/socialbnb/assets/countryImages/countryImagesLarge/costarica.webp';

const colombia = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082384/socialbnb/assets/countryImages/countryImagesLarge/colombia.webp';

const chile = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082383/socialbnb/assets/countryImages/countryImagesLarge/chile.webp';

const capeverde = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082382/socialbnb/assets/countryImages/countryImagesLarge/capeverde.webp';

const canada = canadaImage;

const cameroon = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082381/socialbnb/assets/countryImages/countryImagesLarge/cameroon.webp';

const cambodia = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082380/socialbnb/assets/countryImages/countryImagesLarge/cambodia.webp';

const brasil = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082379/socialbnb/assets/countryImages/countryImagesLarge/brasil.webp';

const bolivia = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082377/socialbnb/assets/countryImages/countryImagesLarge/bolivia.webp';

const bangladesh = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082376/socialbnb/assets/countryImages/countryImagesLarge/bangladesh.webp';

const belgium = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1780043193/socialbnb/assets/countryImages/countryImagesSmall/belgium.webp';

const austria = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082375/socialbnb/assets/countryImages/countryImagesLarge/austria.webp';

const australia = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082374/socialbnb/assets/countryImages/countryImagesLarge/australia.webp';

const argentina = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082373/socialbnb/assets/countryImages/countryImagesLarge/argentina.webp';

const mozambique = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1780043194/socialbnb/assets/countryImages/countryImagesSmall/mozambique.webp';

const eswantini = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1780043230/socialbnb/assets/countryImages/countryImagesSmall/eswantini.jpg';

// Country image mapping
const countryImageMap = {
  argentina,
  australia,
  austria,
  bangladesh,
  belgium,
  bolivia,
  brazil: brasil,
  brasil,
  cambodia,
  cameroon,
  canada,
  'cape verde': capeverde,
  capeverde,
  chile,
  colombia,
  'costa rica': costarica,
  costarica,
  croatia,
  'dominican republic': dominicanrepublic,
  dominicanrepublic,
  ecuador,
  england,
  eswantini,
  estonia,
  finland,
  france,
  germany,
  ghana,
  greece,
  india,
  indonesia,
  italy,
  jordan,
  malawi,
  maldives,
  malta,
  mexico,
  morocco,
  mozambique,
  namibia,
  nepal,
  panama,
  peru,
  philippines,
  portugal,
  romania,
  rwanda,
  'sao tome': saotome,
  saotome,
  scotland: scottland,
  scottland,
  'south africa': southafrica,
  southafrica,
  spain,
  'sri lanka': srilanka,
  srilanka,
  sweden,
  tanzania,
  thailand,
  turkey,
  uganda,
  uzbekistan,
  vietnam,
};

// Country code to normalized country name mapping (ISO 3166-1 alpha-2 codes)
export const countryCodeMap = {
  AR: 'argentina',
  AU: 'australia',
  AT: 'austria',
  BD: 'bangladesh',
  BE: 'belgium',
  BO: 'bolivia',
  BR: 'brasil',
  KH: 'cambodia',
  CM: 'cameroon',
  CA: 'canada',
  CV: 'capeverde',
  CL: 'chile',
  CO: 'colombia',
  CR: 'costarica',
  HR: 'croatia',
  DO: 'dominicanrepublic',
  EC: 'ecuador',
  GB: 'england', // Note: GB is UK, using england image
  EE: 'estonia',
  FI: 'finland',
  FR: 'france',
  DE: 'germany',
  GH: 'ghana',
  GR: 'greece',
  IN: 'india',
  ID: 'indonesia',
  IT: 'italy',
  JO: 'jordan',
  MW: 'malawi',
  MV: 'maldives',
  MT: 'malta',
  MX: 'mexico',
  MA: 'morocco',
  MZ: 'mozambique',
  NA: 'namibia',
  NP: 'nepal',
  PA: 'panama',
  PE: 'peru',
  PH: 'philippines',
  PT: 'portugal',
  RO: 'romania',
  RW: 'rwanda',
  ST: 'saotome',
  SZ: 'eswantini',
  ZA: 'southafrica',
  ES: 'spain',
  LK: 'srilanka',
  SE: 'sweden',
  TZ: 'tanzania',
  TH: 'thailand',
  TR: 'turkey',
  UG: 'uganda',
  UZ: 'uzbekistan',
  VN: 'vietnam',
};

// Continent to country image mapping
const continentImageMap = {
  asia: indonesia,
  'south-america': colombia,
  europe: italy,
};

export const getCountryImage = country => {
  if (!country) {
    return defaultBg;
  }

  const upperCountry = country.toUpperCase().trim();

  const normalizedContinent = country
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '');

  if (continentImageMap[normalizedContinent]) {
    return continentImageMap[normalizedContinent];
  }

  let normalizedCountry;
  if (upperCountry.length === 2 && countryCodeMap[upperCountry]) {
    normalizedCountry = countryCodeMap[upperCountry];
  } else {
    normalizedCountry = country
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '');
  }

  return countryImageMap[normalizedCountry] || defaultBg;
};
